module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.4.0-106.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.4.0.md
// module id = 525
// module chunks = 295